import {
  ActionType,
  IGetHolidayResponse,
  IGetHolidayPayload,
} from "models/dashboard/holidayList";

export const getHolidayAction = (payload: IGetHolidayPayload) => {
  return {
    type: ActionType.HOLIDAY_LIST,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.HOLIDAY_LIST_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IGetHolidayResponse) => {
  return {
    type: ActionType.HOLIDAY_LIST_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.HOLIDAY_LIST_RESET,
  };
};
